(function (Drupal, once) {
  const BODY_COLLAPSED_CLASS = 'filter-collapsed';
  const REGION_HIDDEN_CLASS = 'is-filter-hidden';

  Drupal.behaviors.filterToggle = {
    attach(context) {
      once('filter-toggle', '.filter-toggle', context).forEach((toggle) => {
        const id = toggle.getAttribute('aria-controls');
        const panel = document.getElementById(id);
        if (!panel) return;

        // The wrapper region that creates the "extra gap" when empty.
        const region = panel.closest('.region-filter');

        const setBodyCollapsedClass = (expanded) => {
          document.body.classList.toggle(BODY_COLLAPSED_CLASS, !expanded);
        };

        const setIcon = (expanded) => {
          const use = toggle.querySelector('use');
          if (!use) return;
          const ref = expanded ? '#arrow_up' : '#arrow_down';
          use.setAttribute('href', ref);
          use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', ref);
        };

        const clearEndHandler = () => {
          if (panel._filterToggleOnEnd) {
            panel.removeEventListener('transitionend', panel._filterToggleOnEnd);
            panel._filterToggleOnEnd = null;
          }
        };

        // ---- Initial state ----
        const startExpanded = toggle.getAttribute('aria-expanded') === 'true';
        panel.style.maxHeight = startExpanded ? 'none' : '0px';
        setIcon(startExpanded);
        setBodyCollapsedClass(startExpanded);

        // If starting collapsed, hide the whole region (no gaps).
        if (region) {
          region.classList.toggle(REGION_HIDDEN_CLASS, !startExpanded);
        }

        toggle.addEventListener('click', () => {
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

          // If expanding, ensure region is in layout BEFORE measuring/animating.
          if (!isExpanded && region) {
            region.classList.remove(REGION_HIDDEN_CLASS);
          }

          // Stop any running transition cleanly
          panel.style.transition = 'none';
          const current = panel.getBoundingClientRect().height;
          panel.style.maxHeight = current + 'px';
          panel.offsetHeight; // force reflow
          panel.style.transition = '';

          clearEndHandler();

          if (isExpanded) {
            // COLLAPSE: current px -> 0px, then hide region (display:none via CSS)
            toggle.setAttribute('aria-expanded', 'false');
            setIcon(false);
            setBodyCollapsedClass(false);

            panel._filterToggleOnEnd = function onEnd(e) {
              if (e.propertyName !== 'max-height') return;
              panel.removeEventListener('transitionend', onEnd);
              panel._filterToggleOnEnd = null;

              if (toggle.getAttribute('aria-expanded') === 'false' && region) {
                region.classList.add(REGION_HIDDEN_CLASS);
              }
            };
            panel.addEventListener('transitionend', panel._filterToggleOnEnd);

            requestAnimationFrame(() => {
              panel.style.maxHeight = '0px';
            });
          } else {
            // EXPAND: current px -> scrollHeight px, then cleanup to none
            toggle.setAttribute('aria-expanded', 'true');
            setIcon(true);
            setBodyCollapsedClass(true);

            const target = panel.scrollHeight;

            panel._filterToggleOnEnd = function onEnd(e) {
              if (e.propertyName !== 'max-height') return;
              panel.removeEventListener('transitionend', onEnd);
              panel._filterToggleOnEnd = null;

              if (toggle.getAttribute('aria-expanded') === 'true') {
                panel.style.maxHeight = 'none';
              }
            };
            panel.addEventListener('transitionend', panel._filterToggleOnEnd);

            requestAnimationFrame(() => {
              panel.style.maxHeight = target + 'px';
            });
          }
        });
      });
    }
  };
})(Drupal, once);
